module.exports = __webpack_public_path__ + "img/page-12.01ea0417.jpg";